import React from 'react';
import { observer } from 'mobx-react-lite';
import {
	Button,
	Div,
	InputGroup,
	Typography,
} from '@icecreamsocial/components';
import { useFormik } from 'formik';
import { Checkbox } from '@material-ui/core';
import { CalendarPicker, MinMaxToggle } from '../';
/**
 * @module InvitesFilterForm
 * @category Components
 * @subcategory Presentational
 */
/**
 *
 * @param {object} props
 * @param {function} props.onSubmit the onSubmit function passed to useFormik
 * @param {function} props.onReset the onReset function passed to useFormik
 * @param {object} props.initialValues
 * @param {boolean} [props.initialValues.inviteClickCountSwitch] whether to show min max field
 * @param {number} [props.initialValues.invitesClickCountGTOE]
 * @param {number} [props.initialValues.invitesClickCountLTOE]
 * @param {boolean} [props.initialValues.conversionsSwitch] whether to show min max field
 * @param {number} [props.initialValues.conversionsGTOE]
 * @param {number} [props.initialValues.conversionsLTOE]
 * @param {boolean} [props.initialValues.revenueSwitch] whether to show min max field
 * @param {number} [props.initialValues.revenueGTOE]
 * @param {number} [props.initialValues.revenueLTOE]
 * @param {boolean} [props.initialValues.converted] whether to show unconverted invites
 */
const InvitesFilterForm = ({ onSubmit, onReset, initialValues }) => {
	/**
	 * for the filters
	 */
	const filtersForm = useFormik({
		enableReinitialize: true,
		initialValues,
		onSubmit,
		onReset,
	});

	return (
		<form onSubmit={filtersForm.handleSubmit}>
			<Div display='flex' alignItems='center' justifyContent='space-between'>
				<Typography.H2 typoWeight='500'>Filters</Typography.H2>
				<Button
					onClick={() => {
						filtersForm.handleReset();
						filtersForm.handleSubmit();
					}}
					typoSize='small'
					textDecoration='underline'
					border='none'
					shadow='none'
					hoverShadow='none'
					padding='sm'
					backgroundColor='transparent'
				>
					Reset filters
				</Button>
			</Div>
			<Div as='fieldset' border='none' elWidth='100%'>
				<CalendarPicker
					label='Date Created'
					fromDate={filtersForm.values.fromDate}
					onFromDateChange={filtersForm.handleChange}
					toDate={filtersForm.values.toDate}
					onToDateChange={filtersForm.handleChange}
				/>
			</Div>
			<Div as='fieldset' border='none' elWidth='100%'>
				<Typography.Span
					display='block'
					typoWeight='500'
					typoSize='.9em'
					marginBottom='md'
				>
					Metrics
				</Typography.Span>
				<MinMaxToggle
					name='inviteClickCount'
					label='Lifetime Clicks'
					show={filtersForm.values.inviteClickCountSwitch}
					minValue={filtersForm.values.inviteClickCountGTOE}
					maxValue={filtersForm.values.inviteClickCountLTOE}
					handleChange={filtersForm.handleChange}
				/>
				{/* @todo add lifetime conversions back when it's returned by api again
					<MinMaxToggle
          name="conversions"
          label="Lifetime Conversions"
          show={filtersForm.values.conversionsSwitch}
          minValue={filtersForm.values.conversionsGTOE}
          maxValue={filtersForm.values.conversionsLTOE}
          handleChange={filtersForm.handleChange}
        /> */}
				<MinMaxToggle
					name='revenue'
					label='Lifetime Revenue'
					show={filtersForm.values.revenueSwitch}
					minValue={filtersForm.values.revenueGTOE}
					maxValue={filtersForm.values.revenueLTOE}
					handleChange={filtersForm.handleChange}
				/>
				<InputGroup display='flex' alignItems='center'>
					<Checkbox
						color='primary'
						name='converted'
						value={filtersForm.values.converted}
						checked={filtersForm.values.converted}
						onChange={filtersForm.handleChange}
					/>{' '}
					<InputGroup.Label display='inline-block'>
						Only show converted invites
					</InputGroup.Label>
				</InputGroup>
			</Div>

			<Button
				type='submit'
				disable={!filtersForm.isValid}
				elWidth='100%'
				textColor='bodyInverse'
				backgroundColor='brand'
				padding='sm'
			>
				Apply Filters
			</Button>
		</form>
	);
};

InvitesFilterForm.displayName = 'InvitesFilterForm';
export default observer(InvitesFilterForm);
